const fetchCategory = (keyWindow, id, callback = () => {}) => ({
  type: 'FETCH_CATEGORY',
  payload: {
    keyWindow,
    id,
  },
  callback,
});

const removeCategory = (keyWindow, id, callback = () => {}) => ({
  type: 'REMOVE_CATEGORY',
  payload: {
    keyWindow,
    id,
  },
  callback,
});

const newCategory = (keyWindow, id, callback = () => {}) => ({
  type: 'NEW_CATEGORY',
  payload: {
    keyWindow,
    id,
  },
  callback,
});

const editCategory = (keyWindow, id, callback = () => {}) => ({
  type: 'EDIT_CATEGORY',
  payload: {
    keyWindow,
    id,
  },
  callback,
});

const undoEditCategory = (keyWindow, id, callback = () => {}) => ({
  type: 'UNDO_EDIT_CATEGORY',
  payload: {
    keyWindow,
    id,
  },
  callback,
});


const saveCategory = (keyWindow, id, data, callback = () => {}) => ({
  type: 'SAVE_CATEGORY',
  payload: {
    keyWindow,
    id,
    data,
  },
  callback,
});

const createCategory = (keyWindow, id, data, callback = () => {}) => ({
  type: 'CREATE_CATEGORY',
  payload: {
    keyWindow,
    id,
    data,
  },
  callback,
});


const updateCategory = (id, props, callback = () => {}) => ({
  type: 'UPDATE_CATEGORY',
  payload: {
    id,
    props,
  },
  callback,
});

const undoUpdateCategory = (id, keys, callback = () => {}) => ({
  type: 'UNDO_UPDATE_CATEGORY',
  payload: {
    id,
  },
  callback,
});

export default {
  updateCategory,
  undoUpdateCategory,
  saveCategory,
  removeCategory,
  fetchCategory,
  newCategory,
  undoEditCategory,
  editCategory,
  createCategory
};
